import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LockIcon, UserIcon, AlertCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Login() {
  const [username, setUsername] = useState('aesir');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const {
    login,
    isAuthenticated
  } = useAuth();
  const navigate = useNavigate();
  // Reindirizza alla dashboard se già autenticato
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(username, password);
      if (success) {
        navigate('/');
      } else {
        setError('Credenziali non valide. Riprova.');
      }
    } catch (err) {
      setError('Si è verificato un errore durante il login.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen w-full flex items-center justify-end" data-id="element-2192">
      {/* Immagine di sfondo a schermo intero */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/aguHNvPy5Pqg4Vqz5BZ2VL/modern-architecture-national-museum-of-qatar-futu-2024-12-01-00-08-23-utc.jpg')"
    }} data-id="element-2193"></div>
      {/* Container con effetto vetro posizionato nel terzo destro */}
      <div className="relative z-10 w-full max-w-md px-6 mr-6 md:mr-16 lg:mr-24" data-id="element-2194">
        <div className="backdrop-blur-md bg-white/30 rounded-3xl shadow-lg overflow-hidden border border-white/20" data-id="element-2195">
          <div className="px-8 py-10" data-id="element-2196">
            {/* Logo aggiornato */}
            <div className="flex justify-center mb-8" data-id="element-2197">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wC6Jd1LAXf1ddCzhVagfAB/ChatGPT_Image_26_ago_2025%2C_02_12_26_copia.png" alt="CashFirst Logo" className="h-20 w-auto max-w-[80%]" data-id="element-2198" />
            </div>
            {error && <div className="mb-6 rounded-lg bg-red-500/40 backdrop-blur-sm p-4" data-id="element-2199">
                <div className="flex" data-id="element-2200">
                  <div className="flex-shrink-0" data-id="element-2201">
                    <AlertCircleIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-2202" />
                  </div>
                  <div className="ml-3" data-id="element-2203">
                    <h3 className="text-sm font-medium text-white" data-id="element-2204">{error}</h3>
                  </div>
                </div>
              </div>}
            <form onSubmit={handleLogin} className="space-y-6" data-id="element-2205">
              <div data-id="element-2206">
                <label htmlFor="username" className="block text-sm font-medium text-gray-800 mb-2" data-id="element-2207">
                  Username
                </label>
                <div className="relative" data-id="element-2208">
                  <input id="username" name="username" type="text" value={username} onChange={e => setUsername(e.target.value)} required className="w-full h-14 px-4 py-3 bg-white/30 backdrop-blur-sm border border-white/30 rounded-full text-gray-800 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400" placeholder="Username" data-id="element-2209" />
                </div>
              </div>
              <div data-id="element-2210">
                <label htmlFor="password" className="block text-sm font-medium text-gray-800 mb-2" data-id="element-2211">
                  Password
                </label>
                <div className="relative" data-id="element-2212">
                  <input id="password" name="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required className="w-full h-14 px-4 py-3 bg-white/30 backdrop-blur-sm border border-white/30 rounded-full text-gray-800 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400" placeholder="Password" data-id="element-2213" />
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-2214">
                <div className="flex items-center" data-id="element-2215">
                  <input id="remember-me" name="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 rounded border-gray-400 bg-white/20 text-[#1A3E5C] focus:ring-[#1A3E5C]" data-id="element-2216" />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-800" data-id="element-2217">
                    Remember me
                  </label>
                </div>
                <div className="text-sm" data-id="element-2218">
                  <a href="#" className="font-medium text-gray-800 hover:text-gray-900" data-id="element-2219">
                    Forgot Password?
                  </a>
                </div>
              </div>
              <div data-id="element-2220">
                <button type="submit" disabled={isLoading} className="w-full h-14 flex justify-center items-center px-4 py-3 border border-transparent rounded-full shadow-sm text-base font-medium text-[#1A3E5C] bg-white/80 hover:bg-white focus:outline-none focus:ring-2 focus:ring-white" data-id="element-2221">
                  {isLoading ? 'Logging in...' : 'Login'}
                </button>
              </div>
            </form>
            <div className="mt-6 text-center" data-id="element-2222">
              <p className="text-sm text-gray-800" data-id="element-2223">
                Don't have an account?{' '}
                <a href="#" className="font-medium text-gray-800 hover:text-gray-900" data-id="element-2224">
                  Register
                </a>
              </p>
            </div>
            <div className="mt-8" data-id="element-2225">
              <p className="text-center text-xs text-gray-700" data-id="element-2226">
                © 2025 Aesir. Tutti i diritti riservati.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}